var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgApproveOutline20 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7006 2.9217L11.8634 3.04558L12.0664 3.01973L14.1859 2.74981L15.0119 4.72029L15.091 4.90901L15.2797 4.98812L17.2502 5.8141L16.9803 7.93358L16.9544 8.13657L17.0783 8.29944L18.3718 10L17.0783 11.7006L16.9544 11.8634L16.9803 12.0664L17.2502 14.1859L15.2797 15.0119L15.091 15.091L15.0119 15.2797L14.1859 17.2502L12.0664 16.9803L11.8634 16.9544L11.7006 17.0783L10 18.3718L8.29944 17.0783L8.13657 16.9544L7.93358 16.9803L5.8141 17.2502L4.98812 15.2797L4.90901 15.091L4.72029 15.0119L2.74981 14.1859L3.01973 12.0664L3.04558 11.8634L2.9217 11.7006L1.6282 10L2.9217 8.29944L3.04558 8.13657L3.01973 7.93357L2.74981 5.8141L4.72029 4.98812L4.90901 4.90901L4.98812 4.72029L5.8141 2.74981L7.93357 3.01973L8.13657 3.04558L8.29944 2.9217L10 1.6282L11.7006 2.9217Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.125 13.5625L6 10.4625L6.99375 9.48125L9.125 11.5938L13.7563 7L14.75 7.9875L9.125 13.5625Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgApproveOutline20);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/approve-outline-20.7299e94e5966d6f36a1c0f657b3a6f3b.svg";